<div class="filter-container mb-4 flex flex-col gap-2" (click)="onClick($event)">
  <div class="grid grid-cols-3 gap-6 py-2">
    <app-pharmacy-auto-complete
      class="col-span-2"
      [label]="isArabic() ? 'الصيدلية' : 'Pharmacy'"
      [placeholder]="isArabic() ? 'ابحث عن الصيدلية' : 'Search pharmacy'"
      [noResultsText]="isArabic() ? 'لا توجد نتائج مطابقة' : 'No matching results'"
      [clear]="pharmacyClear()"
      (itemSelected)="onPharmacySelected($event)"
      (selectionCleared)="selectedPharmacyId.set(null)"></app-pharmacy-auto-complete>

    <app-assign-representative
      layout="filter"
      [clear]="representativeClear()"
      [pharmacyForm]="representativeForm"
      [showRepresentativeDropdown]="false"
      [representativeResults]="representativeResults()"
      [loadingRepresentative]="representativeLoading()"
      [errorRepresentative]="representativeError()"
      (selectRepresentative)="onRepresentativeSelected($event)"
      (searchChange)="onRepresentativeSearch($event)"></app-assign-representative>

    <app-filter-multi-select
      *hasScope="SCOPES.PHARMACIES.READ_ALL_GOVERNORATES"
      [label]="{ titleAr: 'المحافظة', titleEn: 'Governorate' }"
      [placeholder]="{ titleAr: 'اختر المحافظة', titleEn: 'Choose Governorate' }"
      [items]="governorateOptions()"
      [(selectedIds)]="selectedGovernorateIds"
      [showDropdown]="showGovernorateDropdown()"
      (toggleDropdown)="showGovernorateDropdown.set(!showGovernorateDropdown()); showStatusDropdown.set(false)"
      (selectionChange)="onGovernorateChange($event)"></app-filter-multi-select>

    <app-filter-select-component
      *hasScope="SCOPES.PHARMACIES.READ_ALL_CITIES"
      [label]="isArabic() ? 'المدينة' : 'City'"
      [defaultOption]="isArabic() ? 'كل المدن' : 'All Cities'"
      [options]="cityOptions()"
      [(value)]="selectedCityId"
      (valueChange)="onCityChange($event)"></app-filter-select-component>

    <app-filter-select-component
      *hasScope="SCOPES.PHARMACIES.READ_ALL_REGIONS"
      [label]="isArabic() ? 'المنطقة' : 'Region'"
      [defaultOption]="isArabic() ? 'كل المناطق' : 'All Regions'"
      [options]="regionOptions()"
      [(value)]="selectedRegionId"></app-filter-select-component>

    <app-filter-multi-select
      [label]="{ titleAr: 'الحالة', titleEn: 'Status' }"
      [placeholder]="{ titleAr: 'كل الحالات', titleEn: 'All Statuses' }"
      [items]="statusOptions()"
      [(selectedIds)]="selectedStatusIds"
      [showDropdown]="showStatusDropdown()"
      (toggleDropdown)="showStatusDropdown.set(!showStatusDropdown()); showGovernorateDropdown.set(false)"></app-filter-multi-select>
  </div>

  <div class="border-border flex justify-between border-t pt-4">
    <app-filter-sorting-component
      [orderBy]="filters().orderBy!"
      (orderByChange)="filters().orderBy = $event"
      [orderDir]="filters().orderDir!"
      [sortOptions]="sortOptions()"
      (toggleOrder)="toggleSortOrder.emit()"></app-filter-sorting-component>

    <div class="flex items-end justify-end gap-3">
      <app-submit-button type="secondary" (click)="onReset()">
        <span>{{ isArabic() ? "مسح" : "Clear" }}</span>
      </app-submit-button>
      <app-submit-button type="primary" (click)="onApply()">
        <span>{{ isArabic() ? "تطبيق" : "Apply" }}</span>
      </app-submit-button>
    </div>
  </div>
</div>
